import { UserType } from '../Actions/ActionType'

const initialState = {
  userInfo: false,
  language: 'de',
  translations: {},
  companyInfo: false,
  latitude: false,
  longitude: false
}

const getUser = (state, action) => {
  const newState = {}

  Object.assign(newState, state, {
    userInfo: action.payload,
    language: action.payload.language
  })

  return newState
}

const setData = (state, action) => {
  const newState = {}
  Object.assign(newState, state, action.payload)

  return newState
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case UserType.GET_USER: {
      return getUser(state, action)
    }

    case UserType.SET_USER_REDUCER: {
      return setData(state, action)
    }

    default: {
      return state
    }
  }
}
